module.exports = __webpack_public_path__ + "img/meest.f6d153c8.png";